<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
      <div class="banner">
        <div class="content">
          <div class="banner-title">千橙S2B2C</div>
          <div class="line" />
          <div class="desc">
            帮助品牌/平台企业打造全链路管理平台，通过千橙S2B2C系统+橙易采APP，协助客户整合上游资源，管理中端渠道，赋能下游零售客户，为顾客提供更好的产品和服务
            <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
          </div>
          <div class="btn-wrap">
            <div
                class="btn1"
                @click="openLoginModal"
              >免费试用</div>
            <div class="btn" @click="openModal">立即咨询</div>
          </div>
        </div>
      </div>

      <div class="improve1 " style="height:430px;">
          <div class="sk-block-title1">
              <div class="title1">行业挑战</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content1">

          </div>
      </div>
      <div class="improve" style="height:770px;">
          <div class="sk-block-title1">
              <div class="title1">通过平台整合上下游资源，打通全链路交易</div>
              <!-- <div class="sub-title1">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
          </div>
          <div class="content1">

          </div>
      </div>

      <div class="improve1 " style="height:888px;">
          <div class="sk-block-title1">
              <div class="title1">通过平台整合优质供应链资源，实现高效运营管理，为客户提升更优质<br/>的产品和服务</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2" style="margin-top: 80px;">

          </div>
      </div>
      <div class="improve" style="height:472px;">
          <div class="sk-block-title1">
              <div class="title1">打通厂商/品牌商和下游各级经销渠道，实现各经销渠道明确可控</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content2">

          </div>
      </div>

      <div class="improve1 " style="height:805px;">
          <div class="sk-block-title1">
              <div class="title1">线上线下互通互融，为消费者提供全渠道便捷购物服务</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">

          </div>
      </div>
      <div class="improve" style="height:649px;">
          <div class="sk-block-title1">
              <div class="title1">千橙产品矩阵，为企业客户高效管理全链路交易</div>
              <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
          </div>
          <div class="content3">

          </div>
      </div>
      <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcCommerce/custom_bg1.png" alt="">
            </div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="custom_item">
              <img src="@/assets/images/QcCommerce/custom_bg2.png" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
      <Contact :infoSources="'汇通数科官网-千橙S2B2C'" />
      <TryModal
        v-if="visible"
        :visible="visible"
        info-sources="社群分销"
        @cancel="modalClose"
      />
      <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'7'"
        />
    </div>
    <Footer />
  </div>
  </template>

  <script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import metaInfo from "@/common/util/metaInfo";
  import TryModal from "@/components/TryModal";
  import Contact from "@/components/Contact";
  import LoginModal from '@/components/LoginModal'

  export default {
    metaInfo: metaInfo.QcCommerce,
    components: {
      Header,
      Footer,
      TryModal,
      Contact,
    LoginModal
    },
    data() {
      return {
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        showLogin:false,//是否展示注册弹框
        isLogin:false,//是否注册
      };
    },
    mounted() {},
    methods: {
        // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
      checkBg(item) {
        this.tooItem = item;
        this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
      },
      openModal: function () {
        this.visible = true;
      },
      modalClose: function (data) {
        this.visible = data;
      },
    },
  };
  </script>

  <style lang="less" scoped>
  .programme{
        height:1047px;
        background: #F4F5FB;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content{
          margin-top:49px;
          width: 1200px;
          height:834px;
          background: url("~@/assets/images/QcMarketing/content9.png") no-repeat;
          background-size: 1200px 834px;
      }
  }
  .improve_banner1{
    background-color: #f7f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner1.png") no-repeat center;
        background-size: 1920px 824px;
  }
  .improve_banner2{
        background-color:#f9faff;
        background: url("~@/assets/images/QcMarketing/content_banner2.png") no-repeat center;
        background-size: 1920px 668px;
  }
  .improve_banner3{
    background-color:#f8f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner3.png") no-repeat center;
        background-size: 1920px 692px;
  }
  .improve_banner4{
    background-color:#f8f9fb;
        background: url("~@/assets/images/QcMarketing/content_banner4.png") no-repeat center;
        background-size: 1920px 668px;
  }
  .improve1{
    background: #F8FCFF;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items:center;
      position: relative;
      .content1{
          margin-top:38px;
          width: 1200px;
          height:228px;
          background: url("~@/assets/images/QcCommerce/content1.png") no-repeat;
          background-size: 1200px 228px;
      }
      .content2{
          margin-top:40px;
          width: 1200px;
          height:625px;
          background: url("~@/assets/images/QcCommerce/content3.png") no-repeat;
          background-size: 1200px 625px;
      }
      .content3{
          margin-top:40px;
          width: 1200px;
          height:608px;
          background: url("~@/assets/images/QcCommerce/content5.png") no-repeat;
          background-size: 1200px 608px;
      }
  }
  .improve{
      display: flex;
      flex-direction: column;
      // justify-content: center;
    background: #FFFFFF;
      align-items:center;
      .content1{
          margin-top:62px;
          width: 1200px;
          height:504px;
          background: url("~@/assets/images/QcCommerce/content2.png") no-repeat center;
          background-size: 1200px 504px;
      }
      .content2{
        margin-top:31px;
        //   margin-left: 120px;
          width: 1200px;
          height:271px;
          background: url("~@/assets/images/QcCommerce/content4.png") no-repeat center;
          background-size: 1200px 271px;
      }
      .content3{
          margin-top:40px;
          width: 1200px;
          height:439px;
          background: url("~@/assets/images/QcCommerce/content6.png") no-repeat center;
          background-size: 1200px 439px;
      }
  }

  /deep/ i.el-icon-arrow-left {
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ i.el-icon-arrow-right{
      font-size: 35px;
      font-weight: 600;
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }
  /deep/ button.el-carousel__arrow.el-carousel__arrow--right {
      width: 50px;
      height: 86px;
      border-radius: 0px;
      background-color: rgba(0,0,0,.4);
  }

  .custom{
    height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        height:439px;
        margin: 0 auto;
        // padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        /deep/ .el-carousel__container {
            position: relative;
            height: 439px;
        }
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding:0 150px;
            img{
                width: 1200px;
                height: 439px;
            }
        }
    }
}
  .case{
      background: #F8FBFF;
      .content{
          width: 1200px;
          margin: 0 auto;
          padding: 53px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
              width: 1171px;
              height:397px;
          }
      }
  }

    .banner {
      background: url("~@/assets/images/QcShopkeeper/QcShopkeeper_banner.png") no-repeat center;
      background-size: 100% 100%;
      min-width: 1650px;
      min-height: 420px;
      .content {
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        .banner-title {
          font-size: 48px;
          color: #FFFFFF;
          line-height: 55px;
        }
        .line {
          width: 100px;
          height: 6px;
          background: #28DAFB;
          margin: 16px 0 31px;
        }
        .desc {
            width: 484px;
            height: 84px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 28px;
          .desc-content{
              width: 600px;
              height: 96px;
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
          }
        }
        .btn-wrap {
          display: flex;
          .btn {
            width: 200px;
            height: 58px;
            line-height: 58px;
            border-radius: 6px;
            border: 1px solid #FFFFFF;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
            margin-left:20px;
          }
          .btn1 {
            width: 200px;
            height: 58px;
            line-height: 58px;
            background: #3986FF;
            border-radius: 6px;
            font-size: 22px;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            margin-top: 47px;
          //   margin-left:20px;
          }
        }

    }

  }
  </style>
